export const formatBoolean = (value: boolean): string => {
  return (
    value.toString().charAt(0).toUpperCase() +
    value.toString().slice(1).toLowerCase()
  );
};
